import { createCardPaymentStatusContainer } from './container'
import { CardPaymentStatus as CardPaymentStatusUI } from './ui/card-payment-status'

export const CardPaymentStatus = createCardPaymentStatusContainer(CardPaymentStatusUI)
